import { Card, Grid, Label, Loader } from "@aws-amplify/ui-react";
import { API, graphqlOperation } from "aws-amplify";
import { useEffect, useState } from "react";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";

import { getEquipment } from "graphql/queries";
import SelectSpare from "components/spares/SelectSpare";

const EquipmentSpares = ({
  initialValues,
  onChange: onChangeSpares,
  companyID,
}) => {
  const [sparesSelected, setSparesSelected] = useState([]);
  const [equipments, setEquipments] = useState([]);
  const [loading, setLoading] = useState(false);

  const onChangeSelect = (equipmentID, values) => {
    setSparesSelected((prevSt) => {
      const listUpdated = [...prevSt];
      const index = listUpdated.findIndex(
        (it) => it.equipmentID === equipmentID
      );
      listUpdated[index] = {
        ...listUpdated[index],
        spares: values,
      };
      if (onChangeSpares) onChangeSpares(listUpdated);
      return listUpdated;
    });
  };

  async function fetchEquipments(values) {
    try {
      setLoading(true);
      if (!values || values?.length <= 0) {
        setSparesSelected(initialValues ?? []);
        return;
      }

      const ids = values.map((val) => val.equipmentID);

      if (
        sparesSelected?.every((spare) =>
          ids.some((id) => id === spare.equipmentID)
        ) &&
        ids?.every((spare) =>
          sparesSelected.some((id) => id === spare.equipmentID)
        )
      )
        return;

      const equipmentItems = [];
      if (ids?.length > 0) {
        await Promise.all(
          ids.map(async (id) => {
            const equipmentData = await API.graphql(
              graphqlOperation(getEquipment, {
                id,
              })
            );
            const item = equipmentData.data.getEquipment;
            if (!item.deletedAt) equipmentItems.push(item);
          }) ?? []
        );
      }
      setEquipments(equipmentItems);
    } catch (err) {
      toast.error(strings.responses.errorFetchEquipments);
    } finally {
      setSparesSelected(initialValues);
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchEquipments(initialValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues]);

  if (loading) return <Loader />;

  return (
    sparesSelected?.length > 0 && (
      <>
        <div className="fs-5">{strings.title}</div>
        <Grid
          templateColumns={{ base: "1fr 1fr" }}
          rowGap="15px"
          columnGap="15px"
        >
          {sparesSelected?.map((spareSelected) => {
            const equipmentName =
              equipments?.find((e) => e.id === spareSelected.equipmentID)
                ?.name || "";
            return (
              <Card
                key={spareSelected.equipmentID}
                height="fit-content"
                borderRadius="medium"
                variation="outlined"
              >
                <Label>{equipmentName}</Label>
                <SelectSpare
                  initialValues={spareSelected.spares}
                  excludeSpares={
                    sparesSelected
                      .filter(
                        (sp) => sp.equipmentID !== spareSelected.equipmentID
                      )
                      ?.reduce(
                        (list, current) => [...list, ...(current.spares ?? [])],
                        []
                      ) ?? []
                  }
                  parentName="equipmentID"
                  onChangeSpares={(values) =>
                    onChangeSelect(spareSelected.equipmentID, values)
                  }
                  companyID={companyID}
                />
              </Card>
            );
          })}
        </Grid>
      </>
    )
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Repuestos (Equipos asociados)",
    responses: {
      errorFetchSpares: "Error al consultar repuestos",
      errorFetchEquipments: "Error al consultar equipos",
    },
  },
});

export default EquipmentSpares;
